import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Layout } from "./components/Layout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import ServicePage from "./pages/ServicePage";
import About from "./pages/About";
import Faq from "./pages/Faq";
import { ContentPage } from "./pages/ContentPage";
import NotFound from "./pages/NotFound";
import ThankYou from "./pages/ThankYou";
import { SERVICES } from "./data/services";
import { PAGES } from "./data/pages";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            {SERVICES.map((service) => (
              <Route
                key={service.slug}
                path={service.slug}
                element={<ServicePage service={service} />}
              />
            ))}
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<Faq />} />
            {Object.values(PAGES).map((page) => (
              <Route
                key={page.path}
                path={page.path}
                element={<ContentPage page={page} />}
              />
            ))}
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
